// extracted by mini-css-extract-plugin
module.exports = {"background":"LoadingLogo_background__2Oz81","frame":"LoadingLogo_frame__2rttD","spin":"LoadingLogo_spin__1KJFP","logo":"LoadingLogo_logo__90rJ8","flash":"LoadingLogo_flash__1Odw7"};